import React from "react";
import ReactDOM from "react-dom/client";  // ✅ 修正
import App from "./App";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const theme = createTheme();  // ✅ MUIのテーマを作成

const root = ReactDOM.createRoot(document.getElementById("root"));  // ✅ `createRoot` を使用
root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>  
            <App />
        </ThemeProvider>
    </React.StrictMode>
);
